import { AllFieldTypes } from "./feedbackFields.types";

export enum Steps {
  CANT_GRADE = "cant-grade",
  GRADE = "grade",
  THANKS = "thanks",
  ALREADY_VOTED = "already_voted",
}

export type LegacyImage = string | { largeUri?: string; mediumUri?: string; uri: string };

export type FeedBackFontFilesType = Record<
  string,
  {
    id: number;
    _id: string;
    mimeType: string;
    size: number;
    uri: string;
    originalFilename: string;
  }
>;

export type FeedBackFontType = {
  body: {
    name: string;
    files: FeedBackFontFilesType;
    fallbacks?: string;
  };
};

export type FeedbackDesign = {
  primaryColor: string;
  backgroundColor?: string;
  paperColor?: string;
  questionColor: string;
  customCSS?: string;
  banner?: LegacyImage;
  footer?: LegacyImage;
  fonts?: FeedBackFontType;
  fontFamily?: string;
};

export type FeedbackField = AllFieldTypes;

export type FeedbackFormType = {
  messageHtml?: string;
  message?: string;
  grade?: any;
  comment?: string;
  form?: FeedbackField[];

  // Extra ?
  gradeStarCount?: number;
};

export type FeedbackStrings = {
  feedback?: string;
  grade1to5?: string;
  gradeComment?: string;
  formClosed?: string;
} & Record<string, any>;

export type FeedbackMetadata = {
  programId: string;
  title: string;
  datetime: string;
  eventId: string;
  userId: string;
};

export type Feedback = {
  api: {
    feedback: string;
  };
  showTime?: boolean;
  metadata: FeedbackMetadata;
  defaultValues: Record<string, any>;
  defaultStep: Steps;
  title?: string;
  theme?: "default" | "compact";
  design?: FeedbackDesign;
  questionColor?: string;
  banner?: LegacyImage;
  footer?: LegacyImage;
  user?: Record<string, any>;
  goBackUrl?: string;
  feedback: FeedbackFormType;
  strings: FeedbackStrings;
  isPreview?: boolean;
  options?: {
    expirationDate: Date;
  };
};
